function stripHTML(html) {
    if (typeof document !== 'undefined') {
      const tmp = document.createElement('DIV')
      tmp.innerHTML = html
      return tmp.textContent || tmp.innerText || ''
    }
    return ''
  }
  
export default stripHTML